import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { AdminAuditCatalogKey } from './audit.i18n.js';
import { ADMIN_AUDIT_CATALOG } from './audit.i18n.js';

export type AdminAuditMessageId = `adminAudit:${AdminAuditCatalogKey}`;

const PREFIX_LENGTH = 'adminAudit:'.length;

/** `t()` for the stop-gap `adminAudit:` scope (see `audit.i18n.ts`). */
export function useAuditT(): { t: (id: AdminAuditMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: AdminAuditMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as AdminAuditCatalogKey;
      const raw = ADMIN_AUDIT_CATALOG[locale][key] ?? ADMIN_AUDIT_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
